import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, AssistedSalesActionType } from '../constants';

export class AssistedSalesApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.AssistedSales;

  constructor(
    private action?: AssistedSalesActionType,
    private label?: string,
    private employeeId?: string,
    private sharedPaymentLinkId?: string
  ) {}

  getPayload(): any {
    return {
      event: 'Assisted Sales',
      category: 'Assisted Sales',
      action: this.action,
      label: this.label,
      employeeId: this.employeeId,
      sharedPaymentLinkId: this.sharedPaymentLinkId,
    };
  }
}
